import { t } from "i18next";
import React from "react";
import { YStack } from "tamagui";
import { Body } from "../../../ui/Body";
import { Separator } from "../../../ui/Separator";
import { BusinessProfileQuestions } from "../../components/BusinessProfileQuestions";
import type { BusinessFeedItem } from "../BusinessFeedItem";
import { FeedItemAuthorUI } from "../ui/FeedItemAuthor";

export type FeedItemUserIntroData = {
  authorUid: string;
};

export const getFeedIntroText = () => t("business:feed_intro_text");

export const FeedItemUserIntroUI = ({ item }: { item: BusinessFeedItem }) => {
  const _itemData = item.data.itemData as FeedItemUserIntroData;

  const author = item.maybeAuthor;

  if (!author || !item.businessPlan) return null;

  const hasDescription = !!author.profile?.description;

  return (
    <>
      <FeedItemAuthorUI
        businessUid={item.businessPlan.uid}
        feedItem={item}
        author={author}
        dateTs={item.data.ts}
      />

      <YStack
        paddingVertical={"$large"}
        paddingHorizontal={"$space.larger"}
        gap={"$medium"}
      >
        <Body fontStyle={"italic"}>{getFeedIntroText()}</Body>

        <Separator />

        {hasDescription && <Body>{author.profile?.description}</Body>}

        <BusinessProfileQuestions
          userInfo={author}
          businessPlan={item.businessPlan}
        />
      </YStack>
    </>
  );
};
